<script>
import firebase from "firebase";
import { obtenerUsuario } from "../../apiService/request/Usuarios";
import axios from "../../apiService/config/axios";
const provider = new firebase.auth.GoogleAuthProvider();

export default {
  data() {
    return {};
  },
  methods: {
    async loginGoogle() {
      const vm = this
      vm.$store.dispatch('setCargando', true);
      
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(function() {
        
        firebase.auth().signInWithPopup(provider)
        .then(async data => {
          const user = data.user;
          const token = await user.getIdToken(true); // Obtiene el token
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          const existe = await obtenerUsuario(user.email);

          if (user.email.split("@")[1] === "neumomed.com" && existe.data.existe) {
            vm.$store.dispatch("saveUser", user.displayName); // NOMBRE DEL USUARIO
            vm.$store.dispatch("saveEmail", user.email); // CORREO DEL USUARIO
            vm.$store.dispatch("saveUserImage", user.photoURL); // IMAGEN DEL USUARIO
            vm.$router.replace(
              vm.$route.query.redirect || "/HistoriaClinica"
            );
          } else {
            const mensaje = {
              data: {
                message: "El usuario no tiene permiso para ingresar."
              },
              status: 500
            };
            vm.$store.dispatch("cambiarMensajeModal", mensaje);
            vm.$store.dispatch("cambiarEstadoModal", true);
            data.user.delete();
            firebase.auth().signOut();
          }
          vm.$store.dispatch('setCargando', false);
        })
        .catch((error) => {
          const mensaje = {
            data: {
              message: ""
            },
            status: 500
          };
          switch (error.code) {
            case "auth/wrong-password":
              mensaje.data.message = "Contraseña incorrecta";
              break;
            case "auth/user-not-found":
              mensaje.data.message = `El usuario ${error.email} no existe.`;
              break;
            case "auth/invalid-email":
              mensaje.data.message = `El correo ${error.email} no está registrado.`;
              break;
            default:
              mensaje.data.message = `Ocurrió un error. ${error.message}`;
              console.log(
                "Ocurrió un error con codigo: " +
                  error.code +
                  " - " +
                  error.message
              );
              break;
          }
          this.$store.dispatch('setCargando', false);
          this.$store.dispatch("cambiarMensajeModal", mensaje);
          this.$store.dispatch("cambiarEstadoModal", true);
        });
      });
    }
  }
};
</script>
<template src="./Login.html"></template>
<style src="./Login.scss" lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/Login/Login.vue